import { isServer } from '@/shared/util/ssr';
import type { TGoogleAnalytics } from '@tarslib/types/lib/sharedDoc';
import React from 'react';
import ReactGA from 'react-ga4';

export function useCustomGoogleAnalytics(googleAnalytics: TGoogleAnalytics | undefined) {
  const hasReactGAInitRef = React.useRef(false);
  if (isServer) {
    return;
  }
  const measurementId = googleAnalytics?.measurementId;
  const isValidMeasurementId = !!measurementId?.split('G-')?.[1];
  if (isValidMeasurementId && !hasReactGAInitRef.current) {
    ReactGA.initialize(measurementId);
  }
  hasReactGAInitRef.current = true;
}
